import { useEffect, useState } from 'react';
import { IPostModel } from '../../models';
import { postService } from '../../services/post.service';

export const usePostDetail = ({ id, shortId }: { id?: string; shortId?: string }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [postDetail, setPostDetail] = useState<IPostModel | null>(null);

  const getDetailPost = async (id: string) => {
    try {
      if (id) setPostDetail(null);
      setLoading(true);
      let data: IPostModel | null = null;
      if (shortId) {
        try {
          data = await postService.getPostByShortId(shortId);
        } catch {
          data = null;
        }
      }
      // Fallback: shortId không khớp (vd link từ lịch sử donate dùng postId GUID)
      // → thử tra theo id đầy đủ để nhảy đúng bài.
      if (!data?.id && id) {
        data = await postService.getDetailPost(id);
      }
      setPostDetail(data);
      return data;
    } catch {
      setPostDetail(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    getDetailPost(id);
  }, [id]);

  return {
    loading,
    postDetail,
    getDetailPost,
  };
};
